// Helper to reduce trial bundle folders
export const reduceTrialBundleFolders = (list: any[]): any[] =>
  (list || [])
    .reduce(
      (acc: any, item: any) =>
        ([] as any).concat(
          acc,
          !(item.name === 'index' && item.readOnly)
            ? {
                name: item.name,
                id: item.id,
                level: item.level > -1 ? item.level + 1 : 0,
                group: (Array.isArray(item.folders) && item.folders.length > 0) || !item.code,
                type: item.type,
              }
            : [],
          Array.isArray(item.folders) && item.folders.length > 0
            ? reduceTrialBundleFolders(item.folders)
            : [],
        ),
      [],
    )
    .filter(Boolean);

// Generate trial bundles options
export const getTrialBundlesOptions = (folders: any, removeIndexFolders: (folders: any) => any) => {
  const tb = reduceTrialBundleFolders(removeIndexFolders(folders['trialbooks']) || []);
  if (tb && tb.length > 0) {
    return [{ id: 'trialBundle', name: 'Trial Bundles', level: 0, group: true }, ...tb];
  }
  return [];
};

// Generate team bundles options
export const getTeamBundlesOptions = (folders: any) => {
  const team = reduceTrialBundleFolders(folders['teamBundles'] || []);
  if (team && team.length > 0) {
    return [{ id: 'teamBundles', name: 'Team Bundles', level: 0, group: true }, ...team];
  }
  return [];
};

// Generate private bundles options
export const getPrivateBundlesOptions = (folders: any) => {
  const priv = reduceTrialBundleFolders(folders['privateBundles'] || []);
  if (priv && priv.length > 0) {
    return [{ id: 'privateBundles', name: 'Private Bundles', level: 0, group: true }, ...priv];
  }
  return [];
};

// Get classify type options
export const getClassifyTypeOptions = (filterOptions: any, documents: any) => {
  // First try to get from filterOptions
  if (filterOptions && Array.isArray(filterOptions)) {
    const option = filterOptions.find((opt: any) => opt.filterKey === 'classifyType');
    if (option && option.originalArray && option.originalArray.length > 0) {
      return option.originalArray;
    }
  }

  // If not available, compute from documents
  if (!documents || documents.length === 0) return [];

  const classifyTypes = documents.map((doc: any) => doc.classify?.type).filter(Boolean);

  return Array.from(new Set(classifyTypes)).sort();
};

// Get classify subtype options
export const getClassifySubtypeOptions = (filterOptions: any, documents: any) => {
  // First try to get from filterOptions
  if (filterOptions && Array.isArray(filterOptions)) {
    const option = filterOptions.find((opt: any) => opt.filterKey === 'classifySubtype');
    if (option && option.originalArray && option.originalArray.length > 0) {
      return option.originalArray;
    }
  }

  // If not available, compute from documents
  if (!documents || documents.length === 0) return [];

  const classifySubtypes = documents.map((doc: any) => doc.classify?.subtype).filter(Boolean);

  return Array.from(new Set(classifySubtypes)).sort();
};

// Get authors options
export const getAuthorsOptions = (filterOptions: any, documents: any) => {
  // Prefer precomputed options from worker
  if (filterOptions && Array.isArray(filterOptions)) {
    const option = filterOptions.find((opt: any) => opt.filterKey === 'authors');
    if (option && option.originalArray && option.originalArray.length > 0) {
      return option.originalArray;
    }
  }
  // Fallback: derive from documents
  if (!documents || documents.length === 0) return [];
  const authors = documents.map((doc: any) => doc.author).filter(Boolean);
  return Array.from(new Set(authors)).sort();
};

// Get recipients options
export const getRecipientsOptions = (filterOptions: any, documents: any) => {
  // Prefer precomputed options from worker
  if (filterOptions && Array.isArray(filterOptions)) {
    const option = filterOptions.find((opt: any) => opt.filterKey === 'recipients');
    if (option && option.originalArray && option.originalArray.length > 0) {
      return option.originalArray;
    }
  }
  // Fallback: derive from documents
  if (!documents || documents.length === 0) return [];
  const recipients = documents.map((doc: any) => doc.recipient).filter(Boolean);
  return Array.from(new Set(recipients)).sort();
};
